import api from '../client';

/**
 * Service pour la gestion du calendrier
 */
const calendarService = {
  /**
   * Récupérer les événements
   * @param {Object} params - Paramètres (startDate, endDate, type)
   * @returns {Promise} Liste des événements
   */
  getEvents: async (params = {}) => {
    try {
      const response = await api.get('/calendar/events', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer un événement par son ID
   * @param {string} id - ID de l'événement
   * @returns {Promise} Données de l'événement
   */
  getEventById: async (id) => {
    try {
      const response = await api.get(`/calendar/events/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Créer un nouvel événement
   * @param {Object} eventData - Données de l'événement
   * @returns {Promise} Événement créé
   */
  createEvent: async (eventData) => {
    try {
      const response = await api.post('/calendar/events', eventData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Mettre à jour un événement
   * @param {string} id - ID de l'événement
   * @param {Object} eventData - Nouvelles données
   * @returns {Promise} Événement mis à jour
   */
  updateEvent: async (id, eventData) => {
    try {
      const response = await api.put(`/calendar/events/${id}`, eventData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Supprimer un événement
   * @param {string} id - ID de l'événement
   * @returns {Promise} Confirmation de suppression
   */
  deleteEvent: async (id) => {
    try {
      const response = await api.delete(`/calendar/events/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Mettre à jour le statut d'un événement
   * @param {string} id - ID de l'événement
   * @param {string} status - Nouveau statut (confirmed, cancelled, completed)
   * @returns {Promise} Événement mis à jour
   */
  updateStatus: async (id, status) => {
    try {
      const response = await api.patch(`/calendar/events/${id}/status`, { status });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default calendarService;
